import React from "react";
import styles from "./CTASection.module.css";
import { Container } from "../../common/Container";
import { ctaData } from "../../../data/tidePostData";
import { useIntersectionObserver } from "../../../hooks/useIntersectionObserver";
import clsx from "clsx";

const AppStoreIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={styles.appStoreIcon}>
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
  </svg>
);

const SparklesIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path fillRule="evenodd" d="M9 4.5a.75.75 0 01.721.544l.813 2.846a3.75 3.75 0 002.576 2.576l2.846.813a.75.75 0 010 1.442l-2.846.813a3.75 3.75 0 00-2.576 2.576l-.813 2.846a.75.75 0 01-1.442 0l-.813-2.846a3.75 3.75 0 00-2.576-2.576l-2.846-.813a.75.75 0 010-1.442l2.846-.813A3.75 3.75 0 007.466 7.89l.813-2.846A.75.75 0 019 4.5zM18 1.5a.75.75 0 01.728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 010 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 01-1.456 0l-.258-1.036a2.625 2.625 0 00-1.91-1.91l-1.036-.258a.75.75 0 010-1.456l1.036-.258a2.625 2.625 0 001.91-1.91l.258-1.036A.75.75 0 0118 1.5zM16.5 15a.75.75 0 01.712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 010 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 01-1.422 0l-.395-1.183a1.5 1.5 0 00-.948-.948l-1.183-.395a.75.75 0 010-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0116.5 15z" clipRule="evenodd" />
  </svg>
);

export const CTASection: React.FC = () => {
  const [ref, isVisible] = useIntersectionObserver<HTMLElement>({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <section className={styles.section} ref={ref}>
      <div className={styles.backgroundGlow} />
      <Container>
        <div className={clsx(styles.content, isVisible && styles.visible)}>
          <div className={styles.iconWrapper}>
            <SparklesIcon />
          </div>
          <h2 className={styles.title}>{ctaData.headline}</h2>
          <p className={styles.subtitle}>{ctaData.subheadline}</p>
          <a
            href={ctaData.appStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.cta}
          >
            <AppStoreIcon />
            <div className={styles.ctaText}>
              <span className={styles.ctaSmall}>Download on the</span>
              <span className={styles.ctaLarge}>App Store</span>
            </div>
          </a>
          <p className={styles.note}>Free download. No account required. No ads.</p>
        </div>
      </Container>
    </section>
  );
};
